export default __webpack_public_path__ + "static/media/woodTexture.6619c205.png";